<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能监控轮播图 -->
    <MonitorBanner></MonitorBanner>
    <!-- 智能监控硬件描述 -->
    <MonitoringDescription></MonitoringDescription>
    <!-- 方案场景描述 -->
    <Scene></Scene>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import MonitorBanner from '../../../../components/pc/Programme/MonitorComponents/MonitorBanner.vue'
import MonitoringDescription from '../../../../components/pc/Programme/MonitorComponents/MonitoringDescription.vue'
import Scene from '../../../../components/pc/Programme/MonitorComponents/Scene.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    MonitorBanner,
    MonitoringDescription,
    Scene
  },
};
</script>

<style scoped>
</style>
